import React, { useState } from 'react';
import { api } from '../api/client';

export default function SpinGrantModal({ user, onClose, onDone }) {
  const [amount, setAmount] = useState('1');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post(`/admin/users/${user.id}/grant-spin`, { amount: parseInt(amount, 10) });
      onDone();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h3>Gift Toke Tokens to {user.username}</h3>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Number of Tokens</label>
            <input type="number" min="1" value={amount} onChange={e => setAmount(e.target.value)} required autoFocus />
          </div>
          <div className="btn-row">
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Gifting...' : 'Gift Tokens'}
            </button>
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
